import React from 'react';
import { v4 as uuid } from 'uuid';

import FormControl from '@material-ui/core/FormControl';
import InputBase from '@material-ui/core/InputBase/InputBase';
import InputAdornment from '@material-ui/core/InputAdornment';
import { makeStyles } from '@material-ui/core/styles';

import Button from './Button';

const useStyles = makeStyles((theme) => ({
  inputContainer: {
    width: '100%',
    background: 'var(--app-input-bg)',
    border: '1px solid var(--app-border)',
    borderRadius: '16px',
    outline: 'none',
    marginBottom: '16px',
  },
  inputColor: {
    width: '100%',
    background: 'var(--app-input-bg)',
    height: 60,
    border: '1px solid var(--app-border)',
    borderRadius: '16px',
    outline: 'none',
    marginBottom: '16px',
    '&:active': {
      outline: 'none',
      borderRadius: '16px',
    },
    '&:focus': {
      outline: 'none !important',
      borderRadius: '16px',
    },
    '&:before': {
      outline: 'none',
      borderRadius: '16px',
    }
  },
  inputContainerBorderless: {
    width: '100%',
    background: 'var(--app-input-bg)',
    borderRadius: '16px',
    border: '0',
    outline: 'none',
    height: '45px'
  },
  input: {
    width: '100%',
    height: '60px',
    // height: '58px',
    outline: 'none',
    paddingLeft: '16px',
  },
  search: {
    width: '240px',
    height: '60px',
    outline: 'none',
    border: '1.5px solid var(--app-border)',
    borderRadius: '16px',
    paddingLeft: '20px',
    paddingRight: '20px',
    fontWeight: 'normal !important',
  },
  startAdornment: {
    color: 'var(--app-text-subtle)',
  },
  endAdornment: {
    color: 'var(--app-text-subtle)',
  }
}));

const Search = (props) => {
  const {
    value = '',
    disabled = false,
    borderless = false,
    placeholder = 'Search',
    onChange = () => {},
    onSearchClick = () => {},
    loading = false,
  } = props;

  const classes = useStyles();

  const onKeyDown = (e) => {
    if (e.key === 'Enter') {
      onSearchClick();
    }
  };

  return (
    <FormControl
      className={borderless ? classes.inputContainerBorderless : classes.inputContainer}
    >
      <InputBase
        id={`search${uuid()}`}
        type='text'
        className={classes.input}
        style={{ color: value ? 'var(--app-text)' : 'var(--app-text-subtle)' }}
        value={value}
        placeholder={placeholder}
        onChange={onChange}
        disabled={disabled}
        onKeyDown={onKeyDown}
        endAdornment={
          <InputAdornment position='end' style={{ padding: 4 }}>
            <Button
              text='Search'
              background='var(--app-search-button-bg, #000000)'
              color='var(--app-search-button-text, #ffffff)'
              width={140}
              height={52}
              disabled={!value || loading}
              loading={loading}
              onClick={onSearchClick}
            />
          </InputAdornment>
        }
      />
    </FormControl>
  );
};

export default React.memo(Search);
